import { createStyles, ThemeIcon, Anchor, type MantineGradient } from "@mantine/core"
import { IconBrandVk, IconBrandInstagram, IconBrandTelegram, type TablerIconsProps } from "@tabler/icons-react"
import { type Social, type SocialBrand } from "shared/types/common"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  icon: {
    borderRadius: theme.radius.xl,
    cursor: "pointer",
  },
}))

const icons: { [key in SocialBrand]: [ (props: TablerIconsProps) => JSX.Element, MantineGradient ] } = {
  vk: [ IconBrandVk, { from: "indigo", to: "cyan" } ],
  instagram: [ IconBrandInstagram, { from: "violet", to: "pink", deg: 35 } ],
  telegram: [ IconBrandTelegram, { from: "blue", to: "green", deg: 35 } ],
}

// ----------------------------------------------------------------------

export function SocialButton({ brand, url }: Social): React.JSX.Element {
  const { classes } = useStyles()

  const [ Icon, gradient ] = icons[brand]

  return (
    <Anchor href={url} target="_blank">
      <ThemeIcon className={classes.icon} size="lg" variant="gradient" gradient={gradient}>
        <Icon size="1.3rem"/>
      </ThemeIcon>
    </Anchor>
  )
}
